import { CanvasLayer } from '@/pixi/CanvasLayer'
import { Layers } from '@/static/Layers'
import { resolutionSizes } from '@/store/project-store'

/**
 * This composable is responsible for holding all the CanvasLayers
 */
const canvasLayers: CanvasLayer[] = []
const backgroundLayer = new CanvasLayer(Layers.BACKGROUND, resolutionSizes.portrait)
const textLayer = new CanvasLayer(Layers.TEXT, resolutionSizes.portrait)
const stickerLayer = new CanvasLayer(Layers.STICKER, resolutionSizes.portrait)
const logoLayer = new CanvasLayer(Layers.LOGO, resolutionSizes.portrait)

canvasLayers[Layers.BACKGROUND] = backgroundLayer
canvasLayers[Layers.TEXT] = textLayer
canvasLayers[Layers.STICKER] = stickerLayer
canvasLayers[Layers.LOGO] = logoLayer

const transformerLayer = new CanvasLayer(Layers.TRANSFORMER, resolutionSizes.portrait)
transformerLayer.sortableChildren = true

export default function useLayers () {

  const resetLayers = () => {
    [Layers.BACKGROUND, Layers.LOGO, Layers.STICKER, Layers.TEXT, Layers.TRANSFORMER].forEach(layer => {
      clearLayer(layer)
    })
  }

  const clearLayer = (layer: Layers) => {
    const canvasLayer = layer === Layers.TRANSFORMER ? transformerLayer : canvasLayers[layer]
    const removedDispObjs = canvasLayer.removeChildren()
    removedDispObjs.forEach(dispObj => {
      dispObj.destroy()
    })
  }
  
  const getLayerZIndex = (layer: Layers, index: number, length: number): number => {
    return layer + index / length
  }

  return {
    canvasLayers,
    transformerLayer,
    clearLayer,
    resetLayers,
    getLayerZIndex
  }
}